export const POPUP_BUS = Symbol('POPUP_BUS')